module.exports = __webpack_public_path__ + "static/media/Lato-Bold.a2fb219c.eot";